// @need-translate
import {LOG_CLICK_EVENT} from '../../../logging/logEvent';
import {putTiaraObjectProps} from '../../../logging/putTiaraObjectProps';
import {Toggle} from '../../atoms/Toggle/Toggle';
import {ViewerSettingScrollableItem} from './ViewerSettingScrollableItem';
import {ViewerSettingTwoPageLayoutProps} from './ViewerSettingTwoPageLayoutProps.interface';

export function ViewerSettingTwoPageLayout({
  isMobile,
  isTwoPageLayout,
  onClickTwoLayoutToggle,
  isDisabled,
  ...props
}: ViewerSettingTwoPageLayoutProps) {
  return (
    <ViewerSettingScrollableItem
      isMobile={isMobile}
      title="페이지 두쪽 보기"
      isDisabled={isDisabled}
      {...props}
    >
      <Toggle
        className="h-24pxr w-44pxr px-2pxr"
        isActive={isTwoPageLayout}
        isDisabled={isDisabled}
        {...putTiaraObjectProps({
          click: {
            copy: isTwoPageLayout ? 'off' : 'on',
          },
        })}
        onClickToggle={e =>
          LOG_CLICK_EVENT('두쪽보기_클릭', e, onClickTwoLayoutToggle)
        }
      />
    </ViewerSettingScrollableItem>
  );
}
